<template>
  <div style="display:flex;flex-direction:row" @mouseleave="leaver()">
    <div
      class="information"
      :class="[showNews == false ? 'informationNone' : 'information']"
      @click="showNewsClick"
      @mouseenter="enters()"
    >
      <img src="@/assets/image/rmzx.png" class="rightRmxzImg" />
      <div class="rightColumnFont">热门资讯</div>
    </div>
    <div v-show="showNews">
      <div @mouseleave="leaver()" class="news">
        <!-- 头部选择菜单  -->
        <div class="top">
          <div style="float:left" @click="chooseFunction(1)">
            <div :class="[chooseValue == 1 ? 'newsFontShow' : 'newsFont']">
              景区新闻
            </div>
            <img
              v-show="chooseValue == 1"
              src="@/assets/image/down.png"
              class="downImg"
            />
          </div>
          <div style="float:left" @click="chooseFunction(2)">
            <div
              :class="[chooseValue == 2 ? 'newsFontShow' : 'newsFont']"
              style="margin-left:5.364vw"
            >
              旅游新闻
            </div>
            <img
              v-show="chooseValue == 2"
              src="@/assets/image/down.png"
              class="downImg"
              style="margin-left:5.364vw"
            />
          </div>
        </div>
        <!-- 列表 -->
        <div style="margin-top:1.389vh;">
          <div v-for="item in list" :key="item.key"> 
            <div style="margin:1.7592vh 0px 0px 0.52vw;" @click="seeInfo(item)">
              <div class="listBody">
                <img
                  :src="item.icon"
                  class="leftImg"
                  v-if="item.icon != null"
                />
                <img src="@/assets/image/wys.png" class="leftImg" v-else />
              </div>
              <div style="float:left;text-align:left">
                <div class="newsDesc">
                  {{ item.title }}
                </div>
                <div class="newsTime">[{{ item.createDate }}]</div>
              </div>
              <div style="float:left">
                <div class="newsLine"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getNewsTravel,
  getNewsTravelById,
  getNewsScenic,
  getNewsScenicById,
  getNewsScenicType
} from "@/api/common";
export default {
  name: "news",

  data() {
    return {
      current: 1,
      pageSize: 10,
      chooseValue: 1,
      showNews: false,
      list: []
    };
  },
  mounted() {
    this.getNewsScenicFunction('news_scenic');
  },
  methods: {
    enters() {
      this.showNews = true;
    },
    leaver() {
      this.showNews = false;
    },
    showNewsClick() {
      this.showNews = !this.showNews;
    },
    chooseFunction(type) {
      this.chooseValue = type;
      type == 1 ? this.getNewsScenicFunction('news_scenic') : this.getNewsTravelFunction('news_travel');
    },
    //详情
    seeInfo(info) {
      this.$store.commit("setInfo", info);
      this.$store.commit("setTabPage", this.chooseValue);
      // this.chooseValue == 1
      //   ? this.getNewsScenicFunction('news_scenic')
      //   : this.getNewsTravelFunction('news_travel');
      this.$emit("specialtyListFunction", "NewsTab");
    },
    //点击
    async getNewsTravelByIdFunction(id) {
      const { code, data } = await getNewsTravelById(id);
    },
    //景区点击
    async getNewsScenicByIdFunction(id) {
      const { code, data } = await getNewsScenicById(id);
    },
    //景区
    async getNewsScenicFunction(type) {
      const { code, data } = await getNewsScenicType(this.current, this.pageSize, type);
      if (code == 200) {
        let datalist = data.records;
        let BASE_URL = this.Global;
        datalist.forEach(element => {
          element.icon != null
            ? (element.icon = `${BASE_URL}${element.icon}`)
            : "";
        });
        this.list = datalist.slice(0, 4);
        this.total = data.total;
      }
    },
    //旅游
    async getNewsTravelFunction(type) {
      const { code, data } = await getNewsScenicType(this.current, this.pageSize, type);
      if (code == 200) {
        let datalist = data.records;
        let BASE_URL = this.Global;
        datalist.forEach(element => {
          element.icon != null
            ? (element.icon = `${BASE_URL}${element.icon}`)
            : "";
        });
        this.list = datalist.slice(0, 4);
        this.total = data.total;
      }
    }
  }
};
</script>

<style scoped>
.news {
  width: 19.7395vw;
  height: 85.55vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 11;
  right: 4.63vw;
  text-align: center;
  cursor: pointer;
  font-weight: 400;
  color: #ffffff;
}
.news .top {
  margin-top: 3.98148vh;
  margin-left: 4.479vw;
}
.news .downImg {
  width: 1.1979vw;
  height: 0.55vh;
}
.news .top .newsFontShow {
  line-height: 1.48148vh;
  height: 1.48148vh;
  font-size: 1.48148vh;
  font-weight: bold;
  color: #ffffff;
}
.news .listBody {
  float: left;
  /* border: 1px dashed rgba(255, 255, 255, 0.42); */
}
.news .leftImg {
  width: 8.125vw;
  height: 8.79629vh;
  /* 156 95 */
}
.news .top .newsFont {
  line-height: 1.111vh;
  height: 1.111vh;
  font-size: 1.296vh;
  font-weight: 400;
  color: #ffffff;
}

.information {
  width: 0.2083vw;
  height: 85.55vh;
  background: rgba(8, 96, 87, 1);
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 11;
  right: 24.375vw;
  text-align: center;
  cursor: pointer;
}
.informationNone {
  width: 0.2083vw;
  height: 85.55vh;
  background: rgba(8, 96, 87, 1);
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 11;
  right: 4.635vw;
  text-align: center;
  cursor: pointer;
}
.information .rightRmxzImg {
  width: 2.03125vw;
  height: 13.98vh;
  position: absolute;
  z-index: 11;
  left: -2.03125vw;
  top: 37.3148vh;
}
.information .rightColumnFont {
  font-size: 1.29629vh;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  z-index: 12;
  left: -1.25vw;
  top: 40.37vh;
  margin: 0 auto;
  width: 1.29629vh;
}
.newsDesc {
  width: 9.375vw;
  height: 7.222vh;
  font-size: 1.4814vh;
  color: #ffffff;
  margin-left: 0.26vw;
  text-overflow: ellipsis;
  overflow: hidden;
}
.newsTime {
  width: 7.916vw;
  font-size: 1.2962vh;
  color: #ffffff;
  margin-left: 0.26041vw;
}
.newsLine {
  width: 17.6vw;
  /* height: 0px; */
  /* border: 1px dashed #ffffff; */
  opacity: 0.42;
  margin-top: 1.3889vh;
  margin-bottom: 1.75925vh;
  border-top: 1px dashed #ffffff;
  height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/news.vue